import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImpresionArqueoComponent } from './impresion-arqueo/impresion-arqueo.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ImpresionComponent } from './impresion.component';
import { ImpresionCobroComponent } from './impresion-cobro/impresion-cobro.component';

@NgModule({
    declarations: [
        ImpresionComponent,
        ImpresionArqueoComponent,
        ImpresionComponent,
        ImpresionCobroComponent
    ],
    imports: [
        CommonModule,
        ButtonModule,
        RippleModule,
    ],
    exports: [
        ImpresionComponent,
        ImpresionArqueoComponent,
        ImpresionCobroComponent
    ]
})
export class ImpresionModule { }
